export default __webpack_public_path__ + "static/media/group-org4.73edfec9.jpg";